/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Converts strings to snake_case
 */

export const toSnakeCase = (str: string) => {
  if (!str) {
    return ''
  }
  const snake = str
    // change all runs of space|-|_ to a single -
    .replace(/[\s_-]+/g, '-')
    // change foo(A)Z to foo(-A)Z
    .replace(/([^A-Z-])([A-Z])/g, '$1-$2')
    // change AAA(Z)ee to AAA(-Z)ee
    .replace(/([A-Z])([A-Z])([^A-Z-])/g, '$1-$2$3')
    // strip() leading/trailing hyphens
    .replace(/^[\s_-]+|[\s_-]+$/g, '')
    .toLowerCase()
  return snake.replace(/-/g, '_')
}
